import { enableDragDropTouch } from '@dragdroptouch/drag-drop-touch'

/**
 * HTML5 drag events never fire from touch input, so dragging pilots into crew
 * slots would otherwise need a mouse. This shim (the same one BidBoost uses)
 * watches touch gestures on [draggable] elements and dispatches the drag events
 * the existing handlers already listen for.
 *
 * Press-and-hold mode keeps pages scrollable: a quick swipe that happens to
 * start on a chip scrolls as normal, while holding the chip for a moment picks
 * it up to drag.
 */
export function enableTouchDragDrop() {
  enableDragDropTouch(document, document, {
    isPressHoldMode: true,

    // Attach the listeners even when the device reports no touch points, so
    // touch works on hardware that appears after load. They are inert otherwise.
    forceListen: true,
  })
}
